import type { ReactNode } from "react";

import { PreviewContainer } from "./styledComponents";

interface IMediaPreviewContainerProps {
    children: ReactNode;
    className?: string;
    dataAutomation?: string;
}

export const MediaPreviewContainer = ({ children, className, dataAutomation }: IMediaPreviewContainerProps) => {
    return (
        <PreviewContainer
            className={className}
            data-automation={dataAutomation}
        >
            {children}
        </PreviewContainer>
    );
};
